let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fYGRc")).then(() => parcelRequire('5jud1'));